module.exports = __webpack_public_path__ + "static/media/DoorSpeakerLocked2.dcb9b712.png";